/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useFetch } from "./useFetch";

const useFetchDepartingFromOptions = lang => {
	const [data, setData] = useState([]);
	const [processing, fetchData] = useFetch(
		`${process.env.GATSBY_LPC_API_BASE_URL}SV/search/getGatewayforBrand/${lang}/SWG`
	);
	useEffect(() => {
		fetchData().then(result => {
			setData(result?.map(i => ({ value: i.code, label: i.name })));
		});
	}, []);

	return [data, processing, fetchData];
};

export default useFetchDepartingFromOptions;
export { useFetchDepartingFromOptions };
